import request from '../../utils/request'

const preFix = '/system/sysDept';

export const reqListDept = (data) => {
    return request({
        url: preFix + '/tree',
        method: 'get',
        params: data
    })
}
export const reqInsertDept = (data) => {
    return request({
        url: preFix + '/insert',
        method: 'POST',
        data: data
    })
}
export const reqUpdateDept = (data) => {
    return request({
        url: preFix + '/update',
        method: 'POST',
        data: data
    })
}
export const reqDeleteDeptById = (data) => {
    return request({
        url: preFix + '/delete',
        method: 'get',
        params: data
    })
}
export const reqGetDeptById = (data) => {
    return request({
        url: preFix + '/detail',
        method: 'get',
        params: data
    })
}
